// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  corporateSales: (t, data?, options?) => t('enum.staff-team.corporate-sales.name', data, options),
  engooInternationalCustomerSupport: (t, data?, options?) => t('enum.staff-team.engoo-international-customer-support.name', data, options),
  japanCustomerSupport: (t, data?, options?) => t('enum.staff-team.japan-customer-support.name', data, options),
  koreaCustomerSupport: (t, data?, options?) => t('enum.staff-team.korea-customer-support.name', data, options),
  materials: (t, data?, options?) => t('enum.staff-team.materials.name', data, options),
  phDev: (t, data?, options?) => t('enum.staff-team.ph-dev.name', data, options),
  recruitment: (t, data?, options?) => t('enum.staff-team.recruitment.name', data, options),
  taiwanCustomerSupport: (t, data?, options?) => t('enum.staff-team.taiwan-customer-support.name', data, options),
  testing: (t, data?, options?) => t('enum.staff-team.testing.name', data, options),
  thailandCustomerSupport: (t, data?, options?) => t('enum.staff-team.thailand-customer-support.name', data, options),
  tokyoDev: (t, data?, options?) => t('enum.staff-team.tokyo-dev.name', data, options),
  tutorPayroll: (t, data?, options?) => t('enum.staff-team.tutor-payroll.name', data, options),
  tutorSupport: (t, data?, options?) => t('enum.staff-team.tutor-support.name', data, options),
  /* eslint-enable max-len */
};
